import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from "./app-config.service";
import { WellbeingHubCategory } from '../models/wellbeing-hub.model';
import { AppConfig, IAppConfig } from '../models/core/app-config';

@Injectable({
  providedIn: 'root'
})
export class ResourcesService {
  appConfig: IAppConfig = new AppConfig();
  constructor(private http: HttpClient, private appConfigService: AppConfigService) { 
    this.appConfig = this.appConfigService.getLoadedConfig();
  }

    getWellbeingHubCategories(): Observable<WellbeingHubCategory[]> {
       return this.http.get<WellbeingHubCategory[]>(this.appConfig.resourcesApiUrl + `/wellbeing-categories`);  
    }
}
